interface Props {
  label: string;
  action?: string;
  onAction?: () => void;
}

export function MaSectionHeader({ label, action, onAction }: Props) {
  return (
    <div style={{
      display: "flex", alignItems: "baseline", justifyContent: "space-between",
      padding: "4px 2px 10px", marginTop: 4,
    }}>
      <div className="ma-mono" style={{
        fontSize: 11, letterSpacing: "0.16em",
        textTransform: "uppercase", fontWeight: 600, color: "var(--ma-ink)",
      }}>
        {label}
      </div>
      {action && (
        <button onClick={onAction} style={{
          background: "transparent", border: "none", cursor: "pointer",
          fontFamily: "var(--ma-mono)", fontSize: 11, letterSpacing: "0.1em",
          color: "var(--ma-ink-soft)", textDecoration: "underline",
        }}>{action}</button>
      )}
    </div>
  );
}
